"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Growl;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _layers = require("@site/pattern-library-utils/layers");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-len */

const CloseButton = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "CloseButton",
  class: "core-cjddjpm"
});
const GrowlWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GrowlWrapper",
  class: "core-g11w0690"
});

/**
 * Growl component for displaying notifications with text and optional link.
 * @module Growl
 *
 * @param {Object} props React props
 * @param {string} props.title Optional title displayed in bold at the top
 * @param {string} props.text The main text content to display
 * @param {string} props.icon Optional icon name to display to the left of the title
 * @param {string} props.linkText Optional link text to display
 * @param {string} props.linkHref Optional link URL
 * @param {function} props.onLinkClick Optional function to handle link clicks
 * @param {string} props.fadeOut FadeOut value to auto-close the component in milliseconds ("none", "5000")
 * @returns {React.ReactElement} Growl component.
 * @public
 */
function Growl({
  title,
  text,
  icon,
  linkText,
  linkHref,
  onLinkClick,
  fadeOut = 'none',
  actionOnFadeOut
}) {
  const [showGrowl, setShowGrowl] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setShowGrowl(true);
    if (fadeOut !== 'none') {
      setTimeout(() => {
        closeGrowl();
        if (actionOnFadeOut) {
          actionOnFadeOut();
        }
      }, parseInt(fadeOut, 10));
    }
  }, [fadeOut]);
  function closeGrowl() {
    setShowGrowl(false);
  }
  function handleLinkClick(evt) {
    if (onLinkClick) {
      evt.preventDefault();
      onLinkClick(evt);
    }
  }
  return /*#__PURE__*/_react.default.createElement(GrowlWrapper, {
    "data-cy": "growl",
    "data-show": showGrowl,
    "aria-hidden": !showGrowl
  }, /*#__PURE__*/_react.default.createElement(CloseButton, {
    "data-cy": "close-button",
    onClick: closeGrowl
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "x",
    className: "close",
    fill: "white"
  })), icon && /*#__PURE__*/_react.default.createElement("div", {
    className: "growl-icon",
    "data-cy": "growl-icon"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: icon,
    fill: "#FFEEA9"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "growl-content",
    "data-cy": "growl-content"
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "growl-title",
    "data-cy": "growl-title"
  }, title), text, linkText && (linkHref || onLinkClick) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: linkHref || '#',
    className: "growl-link",
    "data-cy": "growl-link",
    onClick: handleLinkClick
  }, linkText))));
}
Growl.propTypes = {
  title: _propTypes.default.string,
  text: _propTypes.default.string.isRequired,
  icon: _propTypes.default.string,
  linkText: _propTypes.default.string,
  linkHref: _propTypes.default.string,
  onLinkClick: _propTypes.default.func,
  fadeOut: _propTypes.default.string,
  actionOnFadeOut: _propTypes.default.func
};